export default __webpack_public_path__ + "static/media/all-free.01475501.jpg";